import "./_resources/scss/style.scss";
import "./_resources/plugins/icomoon/style.css";
import "./chartSetup"; // Global Chart.js registration

import React, { useState, createContext, useContext } from 'react';
import ReactDOM from 'react-dom/client';
import store from './app/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import ProtectedRoute from "./auth/ProtectedRoute";
import LoginPage from "./auth/LoginPage";
import ToastContainer from "./validation/ToastContainer";
import DashboardPage from "./dashboard/DashboardPage";
import DevicesPage from "./devices/DevicesPage";
import PopupContainer from "./view/popup/PopupContainer";
import ValidatePage from "./rules/validate/ValidatePage";
import ViolationsPage from "./violations/ViolationsPage";
import MsbPage from "./rules/msb/MsbPage";
import AnalysisPage from "./rules/analysis/AnalysisPage";
import ReportsPage from "./reports/ReportsPage";
import RecentViolationsPage from "./recentviolations/RecentViolationsPage";
import DeviceDetailsPage from "./devices/details/DeviceDetailsPage";
import ChangeDetailsPage from "./devices/change-details/ChangeDetailsPage";
import BaselinePage from "./devices/baseline/BaselinePage";
import AddRulesPage from "./rules/add-rules/AddRulesPage";
import ParametersPage from "./rules/parameters/ParametersPage";
import RegistrationPage from "./auth/RegistrationPage";
import SyslogSettingsPage from "./rules/syslog-settings/SyslogSettingsPage";
import LogsPage from "./logs/LogsPage";
import RemoteSyslogServerPage from "./system/remote-syslogserver/RemoteSyslogServerPage";
import LicensePage from "./license/LicensePage";
import NewLicensePage from "./license/NewLicensePage";
import AuthenticationPage from "./auth/AuthenticationPage";
import BackupPage from "./backup/BackupPage";
import AlertNotificationPage from "./alert/AlertNotificationPage";
import SystemStatus from "./system/SystemStatusPage";
import UpgradePage from "./upgrade/UpgradePage";
import LogsRetentionPage from "./system/logsRetention/LogsRetentionPage";
import SystemSettingsPage from "./system/system-settings/SystemSettingsPage";
import ConfigChangesPage from "./devices/config-changes/ConfigChangesPage";
import DeviceAuthorizationPage from "./devices/authorization/DeviceAuthorizationPage";
import RemediationPage from "./rules/remediation/RemediationPage";
import ProcessingTasksPage from "./processing-tasks/ProcessingTasksPage";
//Handle Idle Timeout
import SessionTimeout from './sessionTimeout';
import MlDetectionPage from "./mllogincountdetectionresults/MlDetectionPage";
import VulscanPage from "./networkscan/vulnerabilityscan/VulscanPage";
import InventoryPage from "./networkscan/networkinventory/InventoryPage";
import OTPPage from "./auth/OTPPage";
//import ChatbotV2 from "./view/chatbot/ChatbotV2";

export const AuthContext = createContext([]);
export const useAuth = () => useContext(AuthContext);


export const TableContext = React.createContext({});
export const PopupContext = React.createContext(null);



function App() {

    const [popup, setPopup] = useState(null);

    //Using the browser extension
    //React Performance Devtool to use React Perfromance Extension in Chrome
    // var {registerObserver} = require('react-perf-devtool');

    //upgrade Commented-start 20230515
    // const { registerObserver } = require('react-perf-devtool');
    // window.observer = registerObserver();
    //upgrade Commented-end

    //const [refreshing, setRefreshing] = useState(false);

    // window.addEventListener('beforeunload', function (e) {
    //     e.preventDefault();
    //     e.returnValue = '';
    // });

    // window.addEventListener('beforeunload',(event) => {      
    //         event.preventDefault(); //this line used to to show the confirmation dialog
    //         event.returnValue = ''; // Google Chrome requires returnValue to be set.    
    //         // if (event.returnValue.includes('Reload')) {
    //         //     alert (1);
    //         // }
    //     });


    // DevTeam: June 15, 2022
    // This code is added to control the exit of the application (i.e. close browser)
    // and logout from the app automatically

    // window.addEventListener('load', (event1) => {
    //     //location.reload(true);            
    //     setRefreshing(true);
    //     alert (1);
    // });
    // window.addEventListener('beforeunload',(event) =>{


    //     if (refreshing=true) {
    //         event.preventDefault(); //this line used to to show the confirmation dialog
    //         event.returnValue = ''; // Google Chrome requires returnValue to be set.    
    //     alert (2);
    //     setRefreshing(false);
    //     localStorage.removeItem('access_token');
    //     }


    //}); 


    return (
        <React.StrictMode>
            <Provider store={store}>
                <PopupContext.Provider value={{ popup, setPopup }}>
                    <BrowserRouter basename={process.env.PUBLIC_URL}>
                        <Switch>
                            <Route path={"/login"} component={LoginPage} />
                            <Route path={"/otp"} component={OTPPage} />
                            <ProtectedRoute path={"/registration"} component={RegistrationPage} />
                            <ProtectedRoute exact path={"/"} component={DashboardPage} />
                            <ProtectedRoute path={"/devices"} component={DevicesPage} />
                            <ProtectedRoute path={"/validate"} component={ValidatePage} />
                            <ProtectedRoute path={"/violations"} component={ViolationsPage} />
                            <ProtectedRoute path={"/msb"} component={MsbPage} />
                            <ProtectedRoute path={"/analysis"} component={AnalysisPage} />
                            <ProtectedRoute path={"/reports"} component={ReportsPage} />
                            <ProtectedRoute path={"/recentviolations"} component={RecentViolationsPage} />
                            <ProtectedRoute path={"/mldetection"} component={MlDetectionPage} />
                            <ProtectedRoute path={"/vulscan"} component={VulscanPage} />
                            <ProtectedRoute path={"/inventory"} component={InventoryPage} />
                            <ProtectedRoute path={"/syslog-settings"} component={SyslogSettingsPage} />
                            <ProtectedRoute path={"/logs"} component={LogsPage} />
                            <ProtectedRoute path={"/syslog-server"} component={RemoteSyslogServerPage} />
                            <ProtectedRoute path={"/auth"} component={AuthenticationPage} />
                            <ProtectedRoute path={"/backup"} component={BackupPage} />
                            <ProtectedRoute path={"/upgrade"} component={UpgradePage} />
                            <ProtectedRoute path={"/system-settings"} component={SystemSettingsPage} />
                            <ProtectedRoute path={"/logs-retention"} component={LogsRetentionPage} />
                            <ProtectedRoute path={"/system"} component={SystemStatus} />
                            <ProtectedRoute exact path={"/alert-notifications"} component={AlertNotificationPage} />
                            <ProtectedRoute exact path={"/device-details/:id"} component={DeviceDetailsPage} />
                            <ProtectedRoute exact path={"/device-details/:deviceId/change-details/:id"} component={ChangeDetailsPage} />
                            <ProtectedRoute exact path={"/baseline/:id"} component={BaselinePage} />
                            <ProtectedRoute exact path={"/device-authorizations/:deviceId?"} component={DeviceAuthorizationPage} />
                            <ProtectedRoute exact path={"/config-changes"} component={ConfigChangesPage} />
                            <ProtectedRoute path={"/add-rules/:id?"} component={AddRulesPage} />
                            <ProtectedRoute path={"/parameters"} component={ParametersPage} />
                            <ProtectedRoute path={"/remediation"} component={RemediationPage} />
                            <ProtectedRoute path={"/processing-tasks"} component={ProcessingTasksPage} />
                            <ProtectedRoute path={"/license"} component={LicensePage} />
                            <ProtectedRoute path={"/renew-license"} component={NewLicensePage} />
                        </Switch>
                        <SessionTimeout />
                        {/* <ChatbotV2 /> */}
                    </BrowserRouter>
                    <ToastContainer />
                    <PopupContainer />
                </PopupContext.Provider>
            </Provider>
        </React.StrictMode>
    )
}

// ReactDOM.createRoot(document.getElementById("root")).render(
//     <React.StrictMode>
//         <Provider store={store}>
//             <App />
//         </Provider>
//     </React.StrictMode>,

//     //document.getElementById("root") 
// );


const container = document.getElementById('root');

if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  );
} else {
  console.error('Root container missing in index.html');
}


// const container = document.getElementById('root');

// if (container) {
//   const root = ReactDOM.createRoot(container);
//   root.render(<App />);
// } else {
//   console.error('Root container missing in index.html');
// }

// ReactDOM.createRoot(document.getElementById('root')).render(
//     <React.StrictMode>
//         <Provider store={store}>
//             <App />
//         </Provider>
//     </React.StrictMode>,

//     document.getElementById('root') 
// );

// const container = document.getElementById('root');
// const root = ReactDOM.createRoot(container);
// root.render(<App />);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

